export const SET_CURRENT_FEEDBACK = '@feedback/set-current-feedback';

export function setCurrentFeedback(action) {
  let feedback = null;

  if (action.payload?.data) {
    const type = action.payload.data?.type;
    feedback = action.payload?.data?.message;

    if (!feedback && type === 'error') {
      feedback = 'An error has occured';
    }

    if (!feedback && type === 'success') {
      feedback = 'Success';
    }
  }

  return {
    type: SET_CURRENT_FEEDBACK,
    payload: { feedback, type: action.payload?.data?.type },
  };
}
